import { useMsal } from '@azure/msal-react';
import { useEffect } from 'react';
import { endSessionOnServer } from './connection/session';

const useSessionMonitor = () => {
  const { instance } = useMsal();

  useEffect(() => {
    const interval = setInterval(async () => {
      if (window.location.pathname !== '/login') {
        try {
          // const response = await instance.ssoSilent({
          //   scopes: ['User.Read'],
          //   loginHint: instance.getActiveAccount()?.username ?? '',
          // });
          // Try acquiring a token silently (refreshes the MSAL token cache).
          await instance.acquireTokenSilent({
            scopes: ['User.Read'],
          });
        } catch (error: any) {
          if (error?.name === 'InteractionRequiredAuthError') {
            await endSessionOnServer();
            sessionStorage.clear();
            // await instance.logoutRedirect({
            //   postLogoutRedirectUri: '/',
            //   account: instance.getAccountByHomeId(
            //     instance.getActiveAccount()?.homeAccountId ?? '',
            //   ),
            // });
          }
        }
      }
    }, 30000); // Check every 30 seconds

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [instance]);
};

export default useSessionMonitor;
